import TruncateWithToolTip from 'components/TruncateWithToolTip';
import { Enums } from 'helpers/dropdown-enums';

const Title = ({
  companyName,
  visitorName,
  isAgent,
  isOperator,
  chatSectionType,
  chatInitiatedPlatform,
  isOptInChat
}) => {
  const agentText = () => {
    return (
      <TruncateWithToolTip
        text={companyName}
        limit={24}
        className="chatname-title"
      />
    );
  };
  const optInChatText = () => {
    return (
      <TruncateWithToolTip
        text={visitorName}
        limit={24}
        className="chatname-title"
      />
    );
  };
  const operatorText = () => {
    return (
      <TruncateWithToolTip
        text={visitorName || incomingText()}
        limit={24}
        className="chatname-title"
      />
    );
  };

  const incomingText = () => {
    return chatSectionType === Enums.RoomType.IncomingChat
      ? `New ${chatInitiatedPlatform} Chat`
      : `${chatInitiatedPlatform} Chat`;
  };

  if (isOperator) {
    return operatorText();
  } else if (isOptInChat) {
    return optInChatText();
  } else {
    return agentText();
  }
};

export default Title;
